function WishlistWidgetFactory(container) {
  class WishlistWidget {
    constructor(container, customerEmail, customerFirstName, customerLastName) {
      this.wishlistWidget = container;

      this._init();
    }
    appendHtml(selector, htmlContent, position = "beforeend") {
      const div = selector;
      if (div) {
        div.insertAdjacentHTML(position, htmlContent);
      } else {
        console.warn(`Element with selector "${selector}" not found.`);
      }
    }

    _init() {
      this._setEvents();
      // this._setloggedOutEvents();
      // this._renderCustomElements();
    }

    _setEvents() {
      function hasElement(selector, callback, disconnect = true) {
        const observer = new MutationObserver(() => {
          const div = document.querySelector(selector);
          if (div) {
            callback(div);
            if (!!disconnect) {
              observer.disconnect(); // Stop observing once found
            }
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });
      }

      hasElement(
        ".swym-wishlist-detail .swym-wishlist-detail-header",
        (div) => {
          this.buildWishlistDetailsPage();
        }
      );

      hasElement(
        ".swym-empty-wishlist-container",
        (div) => {
          this._renderCustomElements("empty_list");
        },
        false
      );
      hasElement(
        ".swym-wishlist-selector",
        (div) => {
          this._renderCustomElements("general_header");
        },
        false
      );
    }
    removeWishlistHeader() {
      let isEmptyWishlist = !!document.querySelector(
        ".swym-empty-wishlist-container"
      );

      if (isEmptyWishlist) {
        return;
      }
    }
    buildWishlistDetailsPage() {
      let wishlistDetailsBackBtn = document.querySelector(
        ".swym-wishlist-detail-content .swym-back-btn"
      );
      let detailHeader = document.querySelector(".swym-wishlist-detail-header");
      if (!!detailHeader.querySelector(".swym-back-btn")) {
        return;
      }

      detailHeader.insertBefore(
        wishlistDetailsBackBtn,
        detailHeader.firstChild
      );
    }
    _renderCustomElements(step = "general_header") {
      if (step === "general_header") {
        this.wishlistWidget
          ?.querySelector(`.wishlist-page-section-header--empty`)
          ?.remove();
        if (
          this.wishlistWidget.querySelector(
            `.wishlist-page-section-header--general`
          )
        ) {
          return;
        }
        this.appendHtml(
          this.wishlistWidget,
          `
              <div class="wishlist-page-section-header wishlist-page-section-header--general">
                  <h2 class="wishlist-page-section-title">
                      ${window.themeVariables.translations.wishlist.wishlistPageTitle}
                  </h2>
                  <span class="wishlist-page-section-subtitle">
                      ${window.themeVariables.translations.wishlist.wishlistPageSubtitle}
                  </span>
              </div>
          `,
          "afterbegin"
        );
      }
      if (step === "empty_list") {
        this.wishlistWidget
          ?.querySelector(`.wishlist-page-section-header--general`)
          ?.remove();

        if (
          this.wishlistWidget.querySelector(
            `.wishlist-page-section-header--empty`
          )
        ) {
          return;
        }
        this.appendHtml(
          this.wishlistWidget,
          `
              <div class="wishlist-page-section-header wishlist-page-section-header--empty">
                  <h2 class="wishlist-page-section-title">
                      ${window.themeVariables.translations.wishlist.wishlistPageTitle}
                  </h2>
                  <span class="wishlist-page-section-subtitle">
                      ${window.themeVariables.translations.wishlist.wishlistPageEmpty}
                  </span>
                  <span class="wishlist-page-section-actions">
                      <a
                        href="/collections/all"
                        class="button button--outline button--xl button--inverse"
                        data-no-instant
                      >
                        ${window.themeVariables.translations.wishlist.seeAllProducts}
                      </a>
                  </span>
              </div>
          `,
          "afterbegin"
        );
        this.wishlistWidget?.querySelector(`.swym-wishlist-detail`)?.remove();
      }

      //   for (const filterToggler of this.filterTogglers) {
      //     filterToggler.addEventListener("click", () => {
      //       this.wishlistWidget.classList.toggle("--active");
      //     });
      //   }
    }
  }
  return new WishlistWidget(container);
}
